// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"f32e3b42","280":"f8913767","588":"793f2142","617":"0549476f","683":"c55b0db3","780":"1c35d626","787":"bed44058","835":"241fda9a","867":"067c3450"}[chunkId] + ".chunk.js";
};